module.exports = __webpack_public_path__ + "template.summary-payment-instructions.modal-64bdd4e3.html";